import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { getMerchantProfile, getMerchantSettings } from '../../services/merchant';

export const useMerchantProfile = (merchantId) => {
  return useQuery({
    queryKey: ['merchantProfile', merchantId],
    queryFn: () => getMerchantProfile(merchantId),
    enabled: !!merchantId,
    onError: (error) => {
      toast.error('Failed to load merchant profile');
      console.error('Merchant profile fetch error:', error);
    }
  });
};

export const useMerchantSettings = (merchantId) => {
  return useQuery({
    queryKey: ['merchantSettings', merchantId],
    queryFn: () => getMerchantSettings(merchantId),
    enabled: !!merchantId,
    select: (res) => res?.data?.settings,
    onError: (error) => {
      toast.error('Failed to load merchant settings');
      console.error('Merchant settings fetch error:', error);
    }
  });
};